export default "__VITE_ASSET__CWrbDO0a__"